/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChoiceRadial/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ChoiceRadial({
  children,
  viewPath = "/DesignSystem/ChoiceRadial",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onClick,
  paddingBottom = 8,
  paddingTop = 8,
  width = 100,
  isSelected,
  alignSelf = "center",
  text = "Medicare"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="ChoiceRadial.ChoiceRadial"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-ZLDt9k': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-ZLDt9k': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-ZLDt9k': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-ZLDt9k': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--ml-7-ZLDt9k': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-8-ZLDt9k': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-9-ZLDt9k': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pb-10-ZLDt9k': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pt-11-ZLDt9k': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-12-ZLDt9k': typeof width === 'number' ? `${width}px` : width,'--bc-1-ZLDt9k': isSelected ? "rgba(0,147,201, 0.83)" : isHovered ? "rgba(0,147,201, 0.05)" : "#ffffff",'--bc-4-ZLDt9k': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 0.83)" : "#ebebeb"}}
 className={`views-block ${styles.ChoiceRadial1}`}
>
<span
  data-testid="ChoiceRadial.Text"
  data-view-path={viewPath}
 style={{'--as-13-ZLDt9k': alignSelf,'--c-14-ZLDt9k': isSelected ? "#fff" : isHovered ? "rgba(0,147,201, 0.83)" : "#404040"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}